



























// is used for day/week types
import { Vue, Component, Model, Prop, Ref, Watch } from 'vue-property-decorator';

import MonthSlotDay from './MonthSlotDay.vue';

import { ZERO_BASED_WEEKDAYS } from '../consts';

import { ISOCalendarDate } from '@/utils/date/types';
import { SlotsMap, Slot, VacationSlot, SlotsClinicMap } from '../types';
import { CalendarRef, CalendarRange, ParsedEvent } from '../lib-types';

import { getMonthAdjacentRange } from '@/utils/date';

@Component({
    components: {
        MonthSlotDay,
    }
})
export default class MonthCalendar extends Vue {
    @Model('update:date', { type: String }) date!: ISOCalendarDate
    @Prop({ default: () => [] }) slots!: SlotsMap
    @Prop({ default: () => [] }) slotsClinic!: SlotsClinicMap
    @Ref() readonly calendar!: CalendarRef

    get modelWrapper() {
        return this.date
    }

    set modelWrapper(date: ISOCalendarDate) {
        this.$emit('update:date', date);
    }

    get weekdays() {
        return ZERO_BASED_WEEKDAYS;
    }

    @Watch('date', { immediate: true })
    loadVisibleSlots(date: ISOCalendarDate) {
        const visibleRange = getMonthAdjacentRange(date);
        this.$emit('slots:load', visibleRange);
    }

    formatInterval(day: any) {
        const { hour } = day;
        const nextHour = String(hour + 1);

        return `${String(hour).padStart(2, '0')}:00 - ${nextHour.padStart(2, '0')}:00`;
    }

    change(params: CalendarRange) {
        this.$emit('change', params);
    }

    showEvent({ event }: ParsedEvent<Slot>) {
        this.$emit('select:event', event);
    }
    
    setSchedule(date: ISOCalendarDate) {
        this.$emit('set:schedule', date);
    }

    editSchedule(date: ISOCalendarDate) {
        this.$emit('edit:schedule', date);
    }

    removeSchedule(date: ISOCalendarDate) {
        this.$emit('remove:schedule', date);
    }

    viewDay(date: ISOCalendarDate) {
        this.modelWrapper = date;
        this.$emit('view:day');
    }

    selectVacation(vacationSlot: VacationSlot) {
        this.$emit('select:vacation', vacationSlot);
    }

    public goPreviousPage() {
        this.calendar.prev();
    }

    public goNextPage() {
        this.calendar.next();
    }
}
